import { put, takeEvery } from 'redux-saga/effects';
import {
  saveRoleSuccess,
  editRoleSuccess,
  saveRoleFailure,
} from 'redux/ums-user-management/actions';
import { Notify } from '@flexisaf/flexibull2';
import request from 'utils/request';
import urls from 'utils/config';
import UmsUserManagementActionTypes from '../types';
import { SUCCESS, TOP_RIGHT } from 'utils/constants';
import { networkErrorHandler } from 'utils/errrorHandlers';


const { API_BASE_URL } = urls || {};

export function* saveRole({ payload: { data, cb } }) {
  const url = `${API_BASE_URL}/ums/roles`;

  const response = yield request({
    method: 'post',
    data,
    url,
  });

  if (response.success) {
    yield put(saveRoleSuccess(response.raw));
    Notify(`Role created successfully`, {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
    cb();
  } else {
    networkErrorHandler(response?.statusCode, `Failed to Create Role: ${response.message}`);
    yield put(saveRoleFailure(response.message));
  }
}

export function* onSaveRole() {
  yield takeEvery(
    UmsUserManagementActionTypes.SAVE_ROLE_START,
    saveRole
  );
}

export function* editRole({ payload: { data, cb } }) {
  const url = `${API_BASE_URL}/ums/roles/${data.id}`;

  const response = yield request({
    method: 'put',
    data,
    url,
  });

  if (response.success) {
    yield put(editRoleSuccess(response.raw));
    Notify(`Role updated successfully`, {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
    cb();
  } else {
    networkErrorHandler(response?.statusCode, `Failed to Edit Role: ${response.message}`);
    yield put(saveRoleFailure(response.message));
  }
}

export function* onEditRole() {
  yield takeEvery(
    UmsUserManagementActionTypes.EDIT_ROLE_START,
    editRole
  );
}
